import type { JSX } from 'react';

type FullScreenIconProps = {
  className?: string;
  variant: 'on' | 'off';
};

const FullScreenIcon = (props: FullScreenIconProps): JSX.Element => {
  const { className, variant } = props;
  if (variant === 'on') {
    return (
      <svg
        className={className || ''}
        viewBox="0 0 25 24"
        fill="none"
        id="fson"
      >
        <path
          d="M2.72064 14.3066H10.054V21.64"
          stroke="#F7F8FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.2762 9.41781H14.9429V2.08447"
          stroke="#F7F8FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9429 9.41786L23.4984 0.862305"
          stroke="#F7F8FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.49841 22.8622L10.054 14.3066"
          stroke="#F7F8FA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (variant === 'off') {
    return (
      <svg className={className || ''} viewBox="0 0 23 23" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9651 0.862305H21.8983L22.4984 1.46382V8.39564C22.4984 8.72701 22.2298 8.99564 21.8984 8.99564C21.567 8.99564 21.2984 8.72701 21.2984 8.39564V2.91084L14.2338 9.97546C13.9995 10.2098 13.6196 10.2098 13.3853 9.97546C13.1509 9.74114 13.1509 9.36124 13.3853 9.12693L20.4499 2.0623H14.9651C14.6337 2.0623 14.3651 1.79368 14.3651 1.4623C14.3651 1.13093 14.6337 0.862305 14.9651 0.862305ZM21.8983 0.862305L22.4984 1.4623C22.4984 1.45271 22.4982 1.44311 22.4977 1.43352C22.4945 1.3658 22.4798 1.29852 22.4538 1.23482C22.4245 1.16323 22.3808 1.09616 22.3227 1.03804C22.2648 0.980125 22.198 0.936524 22.1266 0.907239C22.0563 0.878278 21.9792 0.862305 21.8984 0.862305H21.8983ZM1.10789 22.8623H8.03175C8.36312 22.8623 8.63175 22.5936 8.63175 22.2623C8.63175 21.9309 8.36312 21.6623 8.03175 21.6623H2.54702L9.61157 14.5977C9.84588 14.3634 9.84588 13.9835 9.61157 13.7492C9.37725 13.5149 8.99735 13.5149 8.76304 13.7492L1.69841 20.8138V15.3289C1.69841 14.9976 1.42978 14.7289 1.09841 14.7289C0.767042 14.7289 0.498413 14.9976 0.498413 15.3289V22.2622C0.498412 22.2655 0.498438 22.2687 0.49849 22.272C0.499511 22.3361 0.510745 22.4001 0.532194 22.4613"
          fill="#F7F8FA"
        />
      </svg>
    );
  }
  return <></>;
};
export default FullScreenIcon;
